module.exports = __webpack_public_path__ + "img/pull_down_blue.278c39d2.png";